import React from "react";
// import RequestJSON from "../SettlementMISAPI/ResponseJSON";
import APIIntegration_JSON from "./Json_Data/APIIntegration_JSON";
import APIIntergration_Transaction_JSON from "./Json_Data/APIIntergration_Transaction_JSON";

function APIIntegration() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2>API Integration</h2>
              <hr />
            </section>

            {/*  JS Checkout flow video: strat */}
            {/*  JS Checkout flow video. end */}

            <section id="idocs_content" class="mt-20 mb-20">
              <h3>Safexpay Test Environments for API Integration</h3>
              <hr />
            </section>
            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {/* <a href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </a> */}
                    <p>
                    https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/apiRedirection/apiIntegration
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>202402150002</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>EFFd2acI34ArHBhZH1kiHdz8ceSL2swZSXRDnPnvsrk=</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>
            <section id="idocs_content" class="mt-20 mb-20">
              <h3>Safexpay Production Environments</h3>
              <hr />
            </section>
            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    <p>
                    https://pg.safexpay.ae/ms-transaction-core-1-0/apiRedirection/apiIntegration
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>Share by us</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>Share by us</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>
            <section id="idocs_content" class="mt-20 mb-20">
              <h3>Encryption Logic</h3>
              <hr />
            </section>
            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Content-Type</td>
                  <td>AES with 256 Bits</td>
                </tr>
                <tr>
                  <td className="table-color">Content-Type</td>
                  <td>Application/json</td>
                </tr>
                <tr>
                  <td className="table-color">IV</td>
                  <td>0123456789abcdef</td>
                </tr>
                <tr>
                  <td className="table-color">Crypt</td>
                  <td> AES-256-CBC</td>
                </tr>
              </tbody>
            </table>

            <u>
              <h4>Request Parameters</h4>
            </u>

            <p>
              Merchant must send the following parameters to <b>Safexpay</b> PG
              for processing an order.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>
                    Section: Txn_Details (Required Parameters)
                  </th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>ag_id</td>
                  <td>YES</td>
                  <td>Alphabets (11)</td>
                  <td>Aggregator id is “paygate”</td>
                </tr>

                <tr>
                  <td>me_id</td>
                  <td>YES</td>
                  <td> Numeric (20)</td>
                  <td>MerchantID issued to you by Safexpay.</td>
                </tr>

                <tr>
                  <td>order_no</td>
                  <td>YES</td>
                  <td>Alphanumeric (70)</td>
                  <td>
                    {" "}
                    This ID is used by merchants to identify the order. Ensure
                    that you send a <b>unique id</b> with each request. As it
                    generates a unique payment reference number for each order
                    which is sent by the merchant.
                  </td>
                </tr>

                <tr>
                  <td>Amount</td>
                  <td>YES</td>
                  <td> Numeric (20,2)</td>
                  <td>
                    This is your Transaction Amount. You can use up to 2 decimal
                    places. E.g., “150.00”
                  </td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Country code needs to be passed, Country code as “ARE” for
                    United Arab Emirates . “ITA” for Italy. “USA” for United
                    states of America. “GBR” for Great Britain.
                  </td>
                </tr>

                <tr>
                  <td>Currency</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Currency in which you want to process the transaction. AED -
                    Emirati Dirham USD - United States Dollar GBP - Pound
                    Sterling EUR - Euro
                  </td>
                </tr>

                <tr>
                  <td>txn_type</td>
                  <td>YES</td>
                  <td> Alphabets (10)</td>
                  <td>
                    Use Txn_Type as <b> “SALE” </b> which is static witheach
                    request
                  </td>
                </tr>

                <tr>
                  <td>success_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200) <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z), Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    successful transaction.
                  </td>
                </tr>

                <tr>
                  <td>failure_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200 <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z) Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    failed transaction.
                  </td>
                </tr>

                <tr>
                  <td>Channel</td>
                  <td>YES</td>
                  <td>Alphabet (10)</td>
                  <td>
                    Use <b>“WEB”</b> in case of website-based payment or{" "}
                    <b>“MOBILE”</b> in case of mobile app. Static value with
                    each request.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: pg_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>pg_id</td>
                  <td>NO</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Bank Identification code assigned by Safexpay
                    Team only{" "}
                    <b>if the Integration type is Merchant Hosted (SEAMLESS)</b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>Paymode</td>
                  <td>NO</td>
                  <td> Alphabets (2)</td>
                  <td>
                    This is the Paymode Identification code assigned by Safexpay
                    Team only{" "}
                    <b>if the Integration type is Merchant Hosted (SEAMLESS)</b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>Scheme</td>
                  <td>NO</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Scheme Identification code assigned by Safexpay
                    Team only{" "}
                    <b>if the Integration type is Merchant Hosted (SEAMLESS)</b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>emi_months</td>
                  <td>NO</td>
                  <td> Numeric (11)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: card_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>card_no</td>
                  <td>NO</td>
                  <td>Numeric (19)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_month</td>
                  <td>NO</td>
                  <td> Numeric (2)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_year</td>
                  <td>NO</td>
                  <td>Numeric (4)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>cvv</td>
                  <td>NO</td>
                  <td> Numeric (3)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>card_name</td>
                  <td>NO</td>
                  <td> Alphabets (50)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: cust_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>cust_name</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer Name. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>
                    email_id <b>(Mandatory)</b>{" "}
                  </td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (100) Characters allowed: Alphabet (A-Z),
                    (a-z). Numbers @ (at), dot, _ (underscore)
                  </td>
                  <td>
                    Customer's Email ID. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>
                    mobile_no <b>(Mandatory)</b>
                  </td>
                  <td>YES</td>
                  <td>Numeric (15)</td>
                  <td>
                    Customer's Mobile Number. This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>unique_id</td>
                  <td>NO</td>
                  <td> Alphanumeric (100)</td>
                  <td>
                    This is required in case of <b>Stored card feature.</b>
                  </td>
                </tr>

                <tr>
                  <td>is_logged_in</td>
                  <td>YES</td>
                  <td> Alphabets (1)</td>
                  <td>Pass “Y” if user is logged in</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Bill_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>bill_addres</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (400) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words{" "}
                  </td>
                  <td>
                    Customer's Billing Address. This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_city</td>
                  <td>Optional</td>
                  <td>Optional (50)</td>
                  <td>
                    Customer's Billing City. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing State. This is required required for
                    fraud protection.
                  </td>
                </tr>
                <tr>
                  <td>bill_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing Country.This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_zip</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (20) <b>Characters allowed:</b> Alphabet
                    (A-Z),(a-z). Numbers
                  </td>
                  <td>
                    Customer's Billing Zip/Pin Code.This is required for fraud
                    protection.
                  </td>
                </tr>
              </tbody>
            </table>

            {/* <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Ship_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>ship_address</td>
                  <td>Optional</td>
                  <td>
                    Alphanumeric (400) <b> Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words
                  </td>
                  <td>
                    Customer's Shipping Address. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_city</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping City. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping State. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer’s Shipping Country. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_zip</td>
                  <td>Optional</td>
                  <td>Alphanumeric (20)</td>
                  <td>
                    Customer's Shipping Zip/Pin Code. This is required in case
                    of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td>
                    <b>Characters allowed:</b> Alphabet (A-Z),(a-z). Numbers{" "}
                  </td>
                  <td></td>
                </tr>

                <tr>
                  <td>ship_days</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    Approximate number of days required for delivery of goods.
                    This is required in case of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>address_count</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    If customer has more than one addresses stored in your
                    system.
                  </td>
                </tr>
              </tbody>
            </table> */}

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Item_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>item_count</td>
                  <td>Optional</td>
                  <td>Alphanumeric (11)</td>
                  <td>Count of items purchased by customer.</td>
                </tr>

                <tr>
                  <td>item_value</td>
                  <td>Optional</td>
                  <td>Optional (200,2)</td>
                  <td>Comma separated item wise cost</td>
                </tr>

                <tr>
                  <td>item_category</td>
                  <td>Optional</td>
                  <td>Alphanumeric (200)</td>
                  <td>Comma separated item category. E.g., “DVD”</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: UPI_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>Vpa_Address</td>
                  <td>Optional</td>
                  <td>Alphanumeric (100)</td>
                  <td>This is mandatory in case of UPI transactions.</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Other_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>udf_1</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_2</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_3</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_4</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_5</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_6</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_7</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="note-div">
              <b className="aggHost-note">Note :</b>
            </div>

            <ul>
              <li>An order details should be created for every payment.</li>
              <li>
                Order number should be unique for every transaction request.
              </li>
              <li>
                {" "}
                Make sure that you are sending the request in <b> JSON.</b>
              </li>
              <li>
                {" "}
                <b> Encrypting and Decrypting </b> the Request and Response with
                the <b> Merchant Encryption Key.</b>
              </li>
            </ul>

            <h4>Request after Encrypting the Plain Request :</h4>

            <p>
              VRh00VZTfa8jQpIVY9RU/0RKon4826v2EqIhw55C90VOleWSt5rrPVr1G4LcBNF1/8YODJr3+U
              OS6jtZASyyYkzfnlbBB8+eEhBqybU4oqtk6Hzqt7/TEXo/1dUgzaObTmCD0OguTEZJL76yQhR+
              sEiQLGfUpDpnvR36N2p5lOu8TYEEApw03IOu3Z0GAZiM9q+y4bFNdxSUxZaO5HCp5ArUc8lPZ6
              3D+uG7pOi80h3R3TK0tUd6/4eg0A3L+xgyCnI+xfsigLnf31bOAPDA2iX/CK8sM6utnjyQthjQ
              xBbHx6rYUMgHPIJN68LPefYfDZHIl1e2dEUIBZgvPPC+wpX55XOTEn97cN+afikMACS5ZVMdmb
              V3DiUmlPn/ITib/lxRqpOMf7Gu33DZ+6m9FC1A8yHAJCZ2W1pQiI45MmopktxrfZtaMyqEdCtk
              LiXrXvRjETPwWwbHZXZcIDT0IaG+0j3h3h4X/63nsMS6tXOSKbPDKLxJgamrst56wXJ44d1mQO
              IxVfl71L+WVybyi/nB1LqJibxSrFS7CqttHT91W9QcNi0H6SYgszzHccx9XWEGqlbQqb1phrBi
              DAZtyEx9pLNfs5+LLZofhGMhBXnOQ0z1dg9OP/oO6dPapDWqoA9xBDNBl9Hu3CCRlLhhBhSqqB
              UeGzvGoAg/1Hu9QGg38Ezx0xnreqgxAnVcjpZ2Zy+pSqaSVzJSzlhF2UfT4gExkNB8JzDFughb
              wRJYCVDpfV2f07pM6l+R4AIigK5+J5hOpWaVBKnhcsnD/5pHXj01CJUFvCLCH+x4ZJvvV/R3DC
              p/Cllrl2PGrWj2TL+qhAcdTI+Oh8bRlFoh32BKPOJkpPv6NoM/0qiFf141qZpXXOth0tOectBh
              5QEIWTYO7FIMa0WmgmF8lZgshGbzJfztZGH5LmbpqIEiYoeQfNqjZtkTJgTUpr6PGBTsYuWEao
              do62XADVv+TUhC7dng5zpyX3Bfhr0ETDXJbFAwk/c+sdQZehg6Hff00m6uUPhU4TKAFFfc5jfm
              ojdIiQuJ9GNnZ8c9bv7zS6KgXvnkW2AcRF5UN8exEMBac0g6Ofpw+bcbxF86+a5uHDeVdMTwuK
              4q75gQx8JrqHKrm7e55Tcx/HV6XICiukzZp0jXBT40KLWpIPhOymH7nI1RsK6O7L/584DMNTb4
              uZwJDDvV3L9C/ZEi6gWTHOXqgWGAl/dS9fr6ii3hUAg3MEeUCkCQtdFhGtSCxZeQwXcqXYDqhy
              DdzqgvBpMGf3CrORIPo1BqHIKbcZQrLCpDyJMjyJXS904QdPxLGuwozBAGaNG3ykOTuYYQSCcS
              OF2nLY/vl+Jr7r1zNs9pjwYbG7zDewDx9/x7nNvQaMq2bsKkcE8Hq2LTp9rRPN1L+AY5d1KB2U
              I2OYAcOQCvJWNPlNWDeXltWOEPuX2HUaeCCXI3oiX8AuQa9U8UrYpa/bWBuO3iZgMqkdW40MhJ
              HUqIeyAcqaIllY97YFuZVLiD9lATAWY3IPGwhFrg7pvJKRR3tmbKDdCwp2VLLqf45+9qz/pCAr
              6Tz716+ip6BOgkJtDB7blJTKg/YF0IOc+i/dPKgh7woH38kp1YdzDkKxUKrWaNqntrSOtBBwSx
              yvPoNiNSDAcs0L7qOrg6uGbnYONpAyE0Q7myzkZtDgsCtQmUreDCY8CudlxGplXd2YBTbegwjy
              054y4TrEyWnDw26v4+drZqQURuhTaiyLng0fmXaiO4HwwnOJkgthxbc1sccC1Hk9J+Q9p8I39b
              5vjyZWg+DcGHWIuTQR+QnfyammAih16UDScjidvn67kDu8bmj58A9PGeZpDxw/J9KOQdZIYwqZ
              8ujiPXEY9XSjGy04vO8YLzFyHLX+AJrkUQ/S34WlnPns+F77Qm7DRf/OP2wolur1S88Dx6s2oP
              64ZxVK1Z5QyOLs9XWhaKuaLFuMu17bR78iYjT1w0KHmB01oYmecQLcGvxI/eWOvrbeToEO6wY0
              4lCMswSKnqFCfdgz6QYI1aMk9BDCEN1nTGCz1u6OoKbj44NdANeCnXjsBV3cN+d0jbVqUdY5L9
              CmUg6mC6U3FvCXGAlixuS7SFHlL+YU1/mE2N52Qf
            </p>

            <h4>Final Sample Request Format : </h4>

            <p>
              "merchantId": "202307200003", "merchantRequest":
              "VRh00VZTfa8jQpIVY9RU/0RKon4826v2EqIhw55C90VOleWSt5rr
              PVr1G4LcBNF1/8YODJr3+UOS6jtZASyyYkzfnlbBB8+eEhBqybU4oqtk6Hzqt7/TEXo/1dUgza
              ObTmCD0OguTEZJL76yQhR+sEiQLGfUpDpnvR36N2p5lOu8TYEEApw03IOu3Z0GAZiM9q+y4bFN
              dxSUxZaO5HCp5ArUc8lPZ63D+uG7pOi80h3R3TK0tUd6/4eg0A3L+xgyCnI+xfsigLnf31bOAP
              DA2iX/CK8sM6utnjyQthjQxBbHx6rYUMgHPIJN68LPefYfDZHIl1e2dEUIBZgvPPC+wpX55XOT
              En97cN+afikMACS5ZVMdmbV3DiUmlPn/ITib/lxRqpOMf7Gu33DZ+6m9FC1A8yHAJCZ2W1pQiI
              45MmopktxrfZtaMyqEdCtkLiXrXvRjETPwWwbHZXZcIDT0IaG+0j3h3h4X/63nsMS6tXOSKbPD
              KLxJgamrst56wXJ44d1mQOIxVfl71L+WVybyi/nB1LqJibxSrFS7CqttHT91W9QcNi0H6SYgsz
              zHccx9XWEGqlbQqb1phrBiDAZtyEx9pLNfs5+LLZofhGMhBXnOQ0z1dg9OP/oO6dPapDWqoA9x
              BDNBl9Hu3CCRlLhhBhSqqBUeGzvGoAg/1Hu9QGg38Ezx0xnreqgxAnVcjpZ2Zy+pSqaSVzJSzl
              hF2UfT4gExkNB8JzDFughbwRJYCVDpfV2f07pM6l+R4AIigK5+J5hOpWaVBKnhcsnD/5pHXj01
              CJUFvCLCH+x4ZJvvV/R3DCp/Cllrl2PGrWj2TL+qhAcdTI+Oh8bRlFoh32BKPOJkpPv6NoM/0q
              iFf141qZpXXOth0tOectBh5QEIWTYO7FIMa0WmgmF8lZgshGbzJfztZGH5LmbpqIEiYoeQfNqj
              ZtkTJgTUpr6PGBTsYuWEaodo62XADVv+TUhC7dng5zpyX3Bfhr0ETDXJbFAwk/c+sdQZehg6Hf
              f00m6uUPhU4TKAFFfc5jfmojdIiQuJ9GNnZ8c9bv7zS6KgXvnkW2AcRF5UN8exEMBac0g6Ofpw
              +bcbxF86+a5uHDeVdMTwuK4q75gQx8JrqHKrm7e55Tcx/HV6XICiukzZp0jXBT40KLWpIPhOym
              H7nI1RsK6O7L/584DMNTb4uZwJDDvV3L9C/ZEi6gWTHOXqgWGAl/dS9fr6ii3hUAg3MEeUCkCQ
              tdFhGtSCxZeQwXcqXYDqhyDdzqgvBpMGf3CrORIPo1BqHIKbcZQrLCpDyJMjyJXS904QdPxLGu
              wozBAGaNG3ykOTuYYQSCcSOF2nLY/vl+Jr7r1zNs9pjwYbG7zDewDx9/x7nNvQaMq2bsKkcE8H
              q2LTp9rRPN1L+AY5d1KB2UI2OYAcOQCvJWNPlNWDeXltWOEPuX2HUaeCCXI3oiX8AuQa9U8UrY
              pa/bWBuO3iZgMqkdW40MhJHUqIeyAcqaIllY97YFuZVLiD9lATAWY3IPGwhFrg7pvJKRR3tmbK
              DdCwp2VLLqf45+9qz/pCAr6Tz716+ip6BOgkJtDB7blJTKg/YF0IOc+i/dPKgh7woH38kp1Ydz
              DkKxUKrWaNqntrSOtBBwSxyvPoNiNSDAcs0L7qOrg6uGbnYONpAyE0Q7myzkZtDgsCtQmUreDC
              Y8CudlxGplXd2YBTbegwjy054y4TrEyWnDw26v4+drZqQURuhTaiyLng0fmXaiO4HwwnOJkgth
              xbc1sccC1Hk9J+Q9p8I39b5vjyZWg+DcGHWIuTQR+QnfyammAih16UDScjidvn67kDu8bmj58A
              9PGeZpDxw/J9KOQdZIYwqZ8ujiPXEY9XSjGy04vO8YLzFyHLX+AJrkUQ/S34WlnPns+F77Qm7D
              Rf/OP2wolur1S88Dx6s2oP64ZxVK1Z5QyOLs9XWhaKuaLFuMu17bR78iYjT1w0KHmB01oYmecQ
              LcGvxI/eWOvrbeToEO6wY04lCMswSKnqFCfdgz6QYI1aMk9BDCEN1nTGCz1u6OoKbj44NdANeC
              nXjsBV3cN+d0jbVqUdY5L9CmUg6mC6U3FvCXGAlixuS7SFHlL+YU1/mE2N52Qf{" "}
            </p>

            {/* <h3>Screenshot of POSTMAN FYR :</h3>

         

            <div className="demo-img">
              <img src="#" alt="image-pending" width="100px" className="demo-style" />
            </div> */}

            <div className="resq-param">
              <h3>Encrypted Response Parameters :</h3>
              <p>
                "merchantId": "202307200003", "status": "Success",
                "statusMessage": "No Error", "response":
                "s2VYEXZIE3zxpb0wq/XeFUr/gZCvtr21E+sATvcqIjg+Q+NB9f0fTQRl8nI
                V+VAExzHBhgg6/8Mzsx6jQf8kTS0rl0Gx7+18bWyjvThxBZmUUQlVufs9R8E/n1rhdaY50LkM+q9
                U7RrqaavT0g1j3DFdyUdcrEtf7HanShEVkzuyvybdj4ZWfnEft337rZpC12allgA0yGHpPkPWHNW
                d9u3u7x0g1y02ws723ry9E9W59w6WN1qUm6JV2LLDsZ5HhlR/zH9xh1CW0MdbKD9NLl7yrGcPh7p
                kgEJ8tzCsMaUbeqCZHfsV5ZuxgfJ7nR1AI1X8zeI8NTFz3ASvL+dCUTqJvKNGdxMTWOy6eCT0spi
                H1piZZ1vAXhdbYBsMRa0+LPhmKO2jrq/96VKigBGHCEeqzsUXjWICj8aoKBDWYwGGvsgPWsOm0Iv
                hM/CMoWhT/GgmQXlnNRjBcYNWWZTXIEpyD5XD4sp7RplYgAoU9mhZMOn6QMzw0ia+rYooY1l5k/i
                hFAF3olvGjp05losKq5UQ+jlAjXpRHZVJTRjwQrNULx0eYfP20NidQRNAP3dUBQMavuA/iOs99zk
                uF04HXKVT7SSt7JU6Lc3jCTFl1Bi2CHcHBEN99xonryTeyQkQFx/cfDzAXe5yf+Tqy/2aUBJAIHO
                RxmjcCEc0c3CK+KRk3rtidlbN1egoFyEiSisaNmbGy+666hGGpnSXaa+qQJ0LSIJWS9V0XpcHUdN
                mXS0BJ5BrdZWoGiGEhCvJfiGvffOCHM7P2awtILzHDjHMGBiUZN8PSPnAHixNMIc4FAm1oT6KH8d
                4TCE8Zh7IA8g7NwdJX9zWpVthDnfCooqtRzcGvlCGJLx5GmjDj7iMnqoodvNJoZAx//xAZuq2oZV9"
              </p>

              <div className="resq-param-decr">
                {/* <h3>Decrypted Response Parameters :</h3>

                <img
                  src="assets/images/prog1.png"
                  alt="logo"
                  className="resq-param"
                  width="100%"
                  height="300"
                /> */}

                <p className="para-blod">Note : </p>
                <p>
                  You need to decrypt the Response, then the plain Response
                  should execute after creating the HTML page with the above
                  data for the same through Browser
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <APIIntegration_JSON />
            <APIIntergration_Transaction_JSON />
          </div>
        </div>
      </div>
    </div>
  );
}
export default APIIntegration;
